<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table
      :data="client"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="width: 100%"
      height="600"
      :border="true"
    >
      <el-table-column label="客户名称" width="150">
        <template slot-scope="scope" style="max-height: 100%">
          <el-link type="primary" @click="handleDetail(scope.row)">
            {{ scope.row.ClientName }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="Code" label="客户编号" sortable></el-table-column>
      <el-table-column
        prop="ContactPerson"
        label="联系人"
        sortable
      ></el-table-column>
      <el-table-column
        prop="ContactPhone"
        label="联系电话"
        sortable
      ></el-table-column>
      <el-table-column prop="Remark" label="备注" sortable></el-table-column>
      <el-table-column
        prop="CreateTime"
        label="创建时间"
        sortable
      ></el-table-column>
      <el-table-column
        prop="CreateUser"
        label="创建者"
        sortable
      ></el-table-column>
      <el-table-column prop="Status" label="状态" width="" sortable>
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Status == 0 ? 'success' : 'info'"
            disable-transitions
          >
            {{ scope.row.Status == 0 ? "正常" : "归档" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-link
            v-if="canEdit"
            type="primary"
            @click="
              () => {
                currentRow = scope.row;
                handleEdit();
              }
            "
          >
            编辑
          </el-link>
          <el-link
            v-if="canDelete"
            type="danger"
            @click="
              () => {
                sels.push(scope.row);
                handleDel();
              }
            "
          >
            删除
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      layout="total, sizes, prev, pager, next, jumper"
      :page-size="pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      class="my-pagination"
    ></el-pagination>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item label="客户名称" prop="ClientName">
          <el-input
            v-model="editForm.ClientName"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="编号" prop="Code">
          <el-input v-model="editForm.Code" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="ContactPerson">
          <el-input
            v-model="editForm.ContactPerson"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="ContactPhone">
          <el-input
            v-model="editForm.ContactPhone"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input
            type="textarea"
            v-model="editForm.Remark"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-select v-model="editForm.Status" placeholder="请选择状态">
            <el-option label="正常" :value="0"></el-option>
            <el-option label="归档" :value="-1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="更新所有单据">
          <el-checkbox v-model="checkedtz">更新</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
        >
          提交
        </el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="120px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="客户名称" prop="ClientName">
          <el-input v-model="addForm.ClientName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="编号" prop="Code">
          <el-input v-model="addForm.Code" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="ContactPerson">
          <el-input
            v-model="addForm.ContactPerson"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="ContactPhone">
          <el-input
            v-model="addForm.ContactPhone"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input
            type="textarea"
            v-model="addForm.Remark"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
        >
          提交
        </el-button>
      </div>
    </el-dialog>

    <!-- 详情 -->
    <el-dialog
      title="详情"
      :visible.sync="isShowDetail"
      v-model="isShowDetail"
      :close-on-click-modal="false"
      append-to-body
    >
      <table class="table-bordered" style="">
        <tr>
          <th style="">客户名称:</th>
          <td>{{ DetailDm.ClientName }}</td>
          <th>编号:</th>
          <td>{{ DetailDm.Code }}</td>
        </tr>
        <tr>
          <th style="">联系人:</th>
          <td>{{ DetailDm.ContactPerson }}</td>
          <th>联系电话:</th>
          <td>{{ DetailDm.ContactPhone }}</td>
        </tr>
        <tr>
          <th style="">备注:</th>
          <td>{{ DetailDm.Remark }}</td>
          <th>状态:</th>
          <td>{{ DetailDm.Status == 0 ? "正常" : "归档" }}</td>
        </tr>
      </table>
    </el-dialog>
  </section>
</template>

<script>
//引入client.js的所有export的对象,并起别名为api,通过api.***访问成员
import * as api from "../../api/client";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filters: {
        name: "",
      },
      client: [],
      total: 0,
      page: 1,
      pageSize: 20,
      listLoading: false,
      sels: [], //列表选中列
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        ClientName: [
          { required: true, message: "请输入客户名称", trigger: "blur" },
        ],
      },
      //编辑界面数据
      editForm: {
        ClientName: "",
        Remark: "",
        Status: 0,
      },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        ClientName: [
          { required: true, message: "请输入客户名称", trigger: "blur" },
        ],
      },
      //新增界面数据
      addForm: {
        ClientName: "",
        Remark: "",
      },
      isShowDetail: false,
      DetailDm: {},
      checkedtz: false,
    };
  },
  computed: {
    //计算属性,判断是否有权编辑
    canEdit() {
      let index = this.buttonList.findIndex((s) => s.name === "编辑");
      return index > -1;
    },
    //计算属性,判断是否有权删除
    canDelete() {
      let index = this.buttonList.findIndex((s) => s.name === "删除");
      return index > -1;
    },
  },
  methods: {
    //单击表格行事件绑定方法
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    //工具条绑定事件方法
    callFunction(item) {
      this.page = 1;
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.page = val;
      this.getClient();
    },
    //获取客户列表
    getClient() {
      let para = {
        page: this.page,
        key: this.filters.name,
        intPageSize: this.pageSize,
      };
      this.listLoading = true;
      api.getClientListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.client = res.data.response.data;
        this.listLoading = false;

        this.currentRow = null;
        this.sels = [];
      });
    },
    //执行删除
    handleDel() {
      if (!this.sels || this.sels.length <= 0) {
        this.$message({
          message: "请勾选要删除的数据",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除选中的记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;

          let para = this.sels.map((item) => item.Id);

          api.batchDeleteClient(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getClient();
          });
        })
        .catch(() => {})
        .finally(() => {
          this.listLoading = false;
        });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      this.checkedtz = false;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        CreateUser: "",
      };
    },
    //执行编辑
    editSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          this.editForm.IsUpdate = this.checkedtz ? 1 : 0;
          let para = Object.assign({}, this.editForm);
          let user = JSON.parse(window.localStorage.user);
          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "用户信息为空，先登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }
          api
            .editClient(para)
            .then((res) => {
              if (res && res.data && res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getClient();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            })
            .finally(() => {
              this.editLoading = false;
            });
        }
      });
    },
    //执行新增
    addSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;

          let para = Object.assign({}, this.addForm);

          let user = JSON.parse(window.localStorage.user);

          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "登录信息已过期,请重新登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }

          api
            .addClient(para)
            .then((res) => {
              if (res && res.data && res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getClient();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            })
            .finally(() => {
              this.addLoading = false;
            });
        }
      });
    },
    // 显示窗口
    handleDetail(row) {
      this.DetailDm = row;
      this.isShowDetail = !this.isShowDetail;
    },
    //勾选表格数据事件绑定方法
    selsChange(sels) {
      this.sels = sels;
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.getClient();
    },
  },
  mounted() {
    this.getClient();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style lang="less" scoped></style>
